import React, {useEffect, useState} from "react";
 
const Modal= ({ isOpen, onClose, children, maxWidth, ...props}) => {
    const [title, setTitle] = useState("");

    useEffect(() => {
        if(props.modalTitle) {
            setTitle(props.modalTitle);
        }}, [props.modalTitle]);

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#00000059",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: "10",
                paddingTop: "70px",
                paddingBottom: "70px",
            }}
        >
            <div
                style={{
                    boxShadow: 'rgba(0, 0, 0, 0.34) 0px 5px 6.27px',
                    backgroundColor: 'rgb(250, 250, 250)',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    maxWidth: maxWidth || '1000px',
                    width: '100%',
                    flex: '1 1 0%',
                    backgroundColor: "white",
                    height: "100%",
                    margin: '70px auto',
                    padding: "15px",
                    paddingLeft: "15px", 
                    paddingRight: "15px",
                    border: "2px solid #0000001a",
                    overflowY: "scroll",
                    zIndex: "20",
                }}

                className="antiAliased"
            >
                <div className="flex spaceBetween">
                 <h3 style={{margin: 0, marginBottom: "5px"}}>{title}</h3>
                <a style={{float: "right", color: "#555555", fontSize: 30}} onClick={onClose}><i className="fa fa-times-circle-o"></i></a>
                </div>
                {children}

            </div>
        </div>
    );
};
 
export default Modal;
